"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Funcion = void 0;
class Funcion {
    constructor(nombre, instrucciones) {
        this.nombre = nombre;
        this.instrucciones = instrucciones;
    }
    Funcion(nombre, instrucciones) {
        this.nombre = nombre;
        this.instrucciones = instrucciones;
    }
}
exports.Funcion = Funcion;
